// extracted by mini-css-extract-plugin
export default {"button":"APButtonSecondary_button__7z9uN","buttonFitContent":"APButtonSecondary_buttonFitContent__ody2z","buttonText":"APButtonSecondary_buttonText__cDc2x"};